import { render } from "./PostOrderStatusView.vue?vue&type=template&id=13cae622"
import script from "./PostOrderStatusView.vue?vue&type=script&lang=js"
export * from "./PostOrderStatusView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__